import { createRouter, createWebHistory } from "vue-router";
import store from '../store';
import ErrorRoutes from './ErrorRoutes';
import AuthRoutes from './AuthRoutes';
import ExtranetRoutes from './ExtranetRoutes';
import MainRoutes from './MainRoutes';

const routes = [
  {
    path: "",
    component: () => import('@/layouts/extranetLayout.vue'),
    children: [
      // Landing publica "/" agora e renderizada pelo Laravel Blade.
      // { path: "",                name: '',              component: () => import('@/views/LandingPageView.vue') , meta: { showPrices: true }         },
      { path: "comercial",      name: 'Comercial',     component: () => import('@/views/LandingPageView.vue') , meta: { showPrices: false }         },
    ]
  },
  ...AuthRoutes,
  ...MainRoutes,
  ...ExtranetRoutes,
  ...ErrorRoutes,
];

const scrollToIdWithRetry = (id, tries = 0) => {
  const el = document.getElementById(id);
  if (el) {
    el.scrollIntoView({ behavior: "smooth", block: "start" });
    return;
  }
  if (tries < 30) setTimeout(() => scrollToIdWithRetry(id, tries + 1), 100);
};

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",

  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition;

    const id = to.meta?.scrollTo;
    if (id) {
      setTimeout(() => scrollToIdWithRetry(id), 0);
      return { top: 0 };
    }

    return { top: 0 };
  },
});

router.beforeEach((to, from, next) => {
  const middlewares = to.meta.middleware || [];

  const runMiddlewares = async (index = 0) => {
    if (index < middlewares.length) {
      const middleware = middlewares[index];
      try {
        const result = await middleware(to, from, next);
        if (result?.route) {
          return next({ name: result.route });
        }
      } catch (error) {
        return next(error);
      }
      runMiddlewares(index + 1);
    } else {
      next();
    }
  };

  runMiddlewares();
});

router.afterEach(() => {
  const canonical = window.location.origin + window.location.pathname;

  let link = document.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement('link');
    link.setAttribute('rel', 'canonical');
    document.head.appendChild(link);
  }
  link.setAttribute('href', canonical);

  let og = document.querySelector('meta[property="og:url"]');
  if (!og) {
    og = document.createElement('meta');
    og.setAttribute('property', 'og:url');
    document.head.appendChild(og);
  }
  og.setAttribute('content', canonical);

  if (window.innerWidth < 575) {
    store.commit("navbarMinimize", "minimize");
  }
});

export default router;
